module.exports = __webpack_public_path__ + "assets/img/ping-main.57b5d742.svg";